import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi } from '@shared/api';

interface ViewPinType {
  loading: boolean;
  error: string | null;
  success: boolean;
  change: (id: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useViewPinStore = create<ViewPinType>((set) => ({
  loading: false,
  error: null,
  success: false,

  change: ApiUtils.wrapperApi(async (id, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await CardsApi.viewPinCard(id, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null }),
}));
